/**
 * Domínios padrão Edge/P2P — altere aqui ao adicionar um novo TLD de failover.
 * CMS: Configurações → Manutenção → Plataforma Edge/P2P (global)
 */
export const STREAMING_BACKUP_DOMAIN = 'saydin.site';

export const DEFAULT_EDGE_API_PRIMARY = 'https://api.seumane.online';
export const DEFAULT_EDGE_API_BACKUP = `https://api.${STREAMING_BACKUP_DOMAIN}`;
export const DEFAULT_EDGE_CDN_PRIMARY = 'https://edge.seumane.online';
export const DEFAULT_EDGE_CDN_BACKUP = `https://edge.${STREAMING_BACKUP_DOMAIN}`;
export const DEFAULT_BROKER_PRIMARY = 'wss://broker.seumane.online/signaling';
export const DEFAULT_BROKER_BACKUP = `wss://broker.${STREAMING_BACKUP_DOMAIN}/signaling`;

/** Texto para textarea (1 URL por linha). */
export const DEFAULT_EDGE_API_URLS_LIST = `${DEFAULT_EDGE_API_PRIMARY}\n${DEFAULT_EDGE_API_BACKUP}`;
export const DEFAULT_EDGE_CDN_URLS_LIST = `${DEFAULT_EDGE_CDN_PRIMARY}\n${DEFAULT_EDGE_CDN_BACKUP}`;
export const DEFAULT_BROKER_URLS_LIST = `${DEFAULT_BROKER_PRIMARY}\n${DEFAULT_BROKER_BACKUP}`;
